// extracted by mini-css-extract-plugin
module.exports = {"general":"s8gg2","collapse":"_2UIKs","stacked":"_149OH","columns":"_2Cjvf","tabs":"_3HarN"};